import React, { Fragment, useState, useEffect } from 'react'
import { useQuery } from '@apollo/client'
import styled from 'styled-components'
import { PUBLIC } from '../../apollo/query'
import { AppBar, Badge, Box, Button, Container, Grid, LinearProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, makeStyles } from '@material-ui/core'
import { dateAgoFromNow } from '../../lib/zileLucratoare'
import moment from 'moment'
import Antet from './Antet'
import OfertaModal from './OfertaModal'
import ListaPreModal from './ListaPreModal'
import AcceptariModal from './AcceptariModal'
import { useParams } from "react-router-dom"

const Styles = styled.div`
div {
    @media print {
            break-inside: auto;
    }
};
.printable{
    @media print {
        @page { 
            size:  letter;
            margin: 10mm 20mm 10mm 20mm; 
        };
        body { 
        };
        div {break-inside: auto;}

    }
}`

const useStyles = makeStyles((theme) => ({
    tableContainer: {
        maxHeight: '80vh',
        border: '1px solid #ddd',
        borderRadius: 8,
        boxShadow: theme.shadows[1],
    },
    table: {
        width: "100%",
    },
    headCell: {
        backgroundColor: '#f1f1f1',
        fontWeight: 600,
        fontSize: 14,
        position: 'sticky',
        top: 0,
        zIndex: 1,
        borderBottom: '2px solid #ccc',
    },
    bodyCell: {
        cursor: "pointer",
        fontSize: 13,
        padding: '8px 12px',
        verticalAlign: 'top',
        fontWeight: 500,
        color: "navy",
        borderBottom: '1px solid #eee',
    },
    stripedRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: 'lightgrey',
        },
        '&:hover': {
            backgroundColor: 'azure',
        },
    },
    link: {
        color: theme.palette.primary.main,
        cursor: 'pointer',
        textDecoration: 'underline',
        fontSize: 13,
    },
}));

export default function PublicModule() {
    const params = useParams()
    const { companyId } = params || {}
    const classes = useStyles()
    const [company, setCompany] = useState()
    const [currentItem, setCurrentItem] = useState()
    const [currentDoc, setCurrentDoc] = useState()
    let from = moment(dateAgoFromNow(365))
    // from = from.subtract(30, "days")
    from = from.format("YYYY-MM-DD")
    // const from = moment().startOf("year").format("YYYY-MM-DD")
    const to = moment().clone().format("YYYY-MM-DD")

    const { data, loading, error } = useQuery(PUBLIC, {
        variables: {
            data: {
                companyId: companyId || 0,
                from: from,
                to: to
            }
        }
    })


    useEffect(() => {
        if (data && data.public) {
            setCompany({
                ...data.public.company,
                registru: data.public.company.registru.map(el => ({ ...el, anexe: JSON.parse(el.anexe) })),
                ranguri: data.public.ranguri,
                settings: data.public.settings

            })
        }
    }, [data])


    const setCurrentHandler = (index, type) => ev => {
        ev.preventDefault()
        let c = {
            id: company.id, name: company.name, loc: company.loc, str: company.str, nr: company.nr, jud: company.jud, cui: company.cui,
            phone: company.phone, fax: company.fax, email: company.email
        }
        c = { ...c, registru: company.registru[index], ranguri: company.ranguri, settings: company.settings }
        setCurrentItem(c); setCurrentDoc(type)
    }

    return (
        <Container maxWidth="xl">

            {loading && <LinearProgress />}
            {error && <pre>{JSON.stringify(error, null, 4)}</pre>}
            {company &&
                <Fragment>
                    <AppBar position="sticky" color="inherit" style={{ padding: "10px" }}>
                        {/* <Antet data={data.public.company} /> */}
                        <Grid container spacing={2} alignItems="center">
                            <Grid item sm={4} xs={12}>
                                <Typography variant="h4" color="primary" style={{ fontWeight: 800, textAlign: "center" }}>
                                    {data?.public?.company?.name}
                                </Typography>
                                <Typography variant="body1" color="primary" style={{ fontWeight: 400, textAlign: "center" }}>
                                    JUDEȚUL {data?.public?.company?.jud}
                                </Typography>
                            </Grid>
                            <Grid item sm={8} xs={12}>
                                <Typography variant="h5" style={{ fontWeight: 700, textAlign: "center", color: "grey" }}>
                                    OFERTE DE VÂNZĂRI TERENURI AGRICOLE EXTRAVILAN <br />
                                    <small>
                                        depuse în perioada {' '}
                                        {moment(data.public.from).format("DD.MM.YYYY")}
                                        {' '}-{' '}
                                        {moment(data.public.to).format("DD.MM.YYYY")}
                                    </small>
                                </Typography>

                            </Grid>
                        </Grid>
                    </AppBar>
                    <Box style = {{paddingLeft:"10px", paddingRight:"10px"}}>
                    <TableContainer className={classes.tableContainer}>
                        <Table stickyHeader className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.headCell}>Nr/Data</TableCell>
                                    <TableCell className={classes.headCell} align="left">Ofertant(i)</TableCell>
                                    <TableCell className={classes.headCell} align='center'>Suprafața totală <br />(ha)</TableCell>
                                    <TableCell className={classes.headCell}>Cota parte<br />(fracție și ha)</TableCell>
                                    <TableCell className={classes.headCell} align="center">Nr. C.F<br />/ Localitatea</TableCell>
                                    <TableCell className={classes.headCell} align="center">Tarla/lot</TableCell>
                                    <TableCell className={classes.headCell} align="center">Parcelă</TableCell>
                                    <TableCell className={classes.headCell} align="center">Categorie</TableCell>
                                    <TableCell className={classes.headCell} align="center">Preț(lei)</TableCell>
                                    <TableCell className={classes.headCell} align="center">Documente</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {company.registru.map((e, i) => (
                                    <TableRow key={i} className={classes.stripedRow}>
                                        <TableCell className={classes.bodyCell} align="center">
                                            {e.nr} / {moment(e.dt).format('DD.MM.YYYY')}
                                        </TableCell>
                                        <TableCell className={classes.bodyCell} style={{ width: "25%" }}>
                                            {e.ofertanti.map((o, ox) => (
                                                <span key={ox}>
                                                    {o.titular.name}
                                                    {ox < e.ofertanti.length - 1 && ', '}
                                                </span>
                                            ))}
                                        </TableCell>
                                        <TableCell className={classes.bodyCell} align="center">{e.anexe.terenHa}</TableCell>
                                        <TableCell className={classes.bodyCell} align="center">{e.anexe.cotaParte}</TableCell>
                                        <TableCell className={classes.bodyCell} align="center">{e.anexe.terenCf} / {e.anexe.terenCfLoc}</TableCell>
                                        <TableCell className={classes.bodyCell} align="center">{e.anexe.terenTarlaLot}</TableCell>
                                        <TableCell className={classes.bodyCell} align="center">{e.anexe.terenParcela}</TableCell>
                                        <TableCell className={classes.bodyCell} align="center">{e.anexe.terenCategorie}</TableCell>
                                        <TableCell className={classes.bodyCell} align="center">{e.anexe.terenPret}</TableCell>
                                        <TableCell className={classes.bodyCell} align="center">
                                            <Grid container spacing={1}>
                                                <Grid item xs = {12} sm={12} md={12} lg={4}>
                                                    <Button
                                                        fullWidth
                                                        style={{ textTransform: "none", lineHeight: 1.1, fontSize: "0.9em", padding: "0.3em" }}
                                                        variant="outlined" color="primary"
                                                        onClick={setCurrentHandler(i, 'oferta')}
                                                    >
                                                        Ofertă de<br />vânzare
                                                    </Button>
                                                </Grid>
                                                <Grid item xs = {12} sm={12} md={12} lg={4}>
                                                    <Button
                                                        fullWidth
                                                        style={{ textTransform: "none", lineHeight: 1.1, fontSize: "0.9em", padding: "0.3em" }}
                                                        variant="outlined" color="primary"
                                                        onClick={setCurrentHandler(i, 'listapre')}
                                                    >
                                                        Listă<br />preemptori
                                                    </Button>
                                                </Grid>
                                                <Grid item xs = {12} sm={12} md={12} lg={4}>
                                                    <Badge badgeContent={e?.anexe?.acceptari?.length} color="primary">
                                                    <Button
                                                        fullWidth
                                                        style={{ textTransform: "none", lineHeight: 1.1, fontSize: "0.9em", padding: "0.3em" }} 
                                                        variant="outlined" color="primary"
                                                        disabled = {e?.anexe?.acceptari?.length < 1}
                                                        onClick={setCurrentHandler(i, 'acceptari')}
                                                    >
                                                        Comunicări<br /> acceptare
                                                    </Button>
                                                    </Badge>
                                                </Grid>
                                            </Grid>

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
</Box>

                </Fragment>
            }
            {currentDoc === "oferta" && (
                <OfertaModal data={currentItem} onClose={() => { setCurrentItem(); setCurrentDoc(); }} />
            )}
            {currentDoc === "listapre" && (
                <ListaPreModal data={currentItem} onClose={() => { setCurrentItem(); setCurrentDoc(); }} />
            )}
            {currentDoc === "acceptari" && (
                <AcceptariModal data={currentItem} onClose={() => { setCurrentItem(); setCurrentDoc(); }} />
            )}
        </Container>
    )
}
